import { logError } from "../../../utils/error";
const SCHEMA_STORAGE_KEY = "ragchat_json_schema";
const SCHEMA_QUERY_KEY = "ragchat_json_schema_query";
const SCHEMA_NAME_KEY = "ragchat_json_schema_name";

export interface StoredSchema {
  schema: Record<string, unknown>;
  query: string;
  extractionName: string;
}

export const saveJsonSchema = (schema: Record<string, unknown>, query: string, extractionName: string = "extract_data"): void => {
  try {
    localStorage.setItem(SCHEMA_STORAGE_KEY, JSON.stringify(schema));
    localStorage.setItem(SCHEMA_QUERY_KEY, query);
    localStorage.setItem(SCHEMA_NAME_KEY, extractionName);
  } catch (error) {
    logError("Failed to save JSON schema to localStorage", error);
  }
};

export const getStoredSchema = (): StoredSchema | null => {
  try {
    const schemaStr = localStorage.getItem(SCHEMA_STORAGE_KEY);
    const query = localStorage.getItem(SCHEMA_QUERY_KEY);
    const extractionName = localStorage.getItem(SCHEMA_NAME_KEY);

    if (!schemaStr || !query || !extractionName) {
      return null;
    }

    return {
      schema: JSON.parse(schemaStr),
      query,
      extractionName
    };
  } catch (error) {
    logError("Failed to retrieve JSON schema from localStorage", error);
    return null;
  }
};

export const getJsonSchema = (): Record<string, unknown> | null => {
  const storedSchema = getStoredSchema();
  return storedSchema ? storedSchema.schema : null;
};

export const clearStoredSchema = (): void => {
  try {
    localStorage.removeItem(SCHEMA_STORAGE_KEY);
    localStorage.removeItem(SCHEMA_QUERY_KEY);
    localStorage.removeItem(SCHEMA_NAME_KEY);
  } catch (error) {
    logError("Failed to clear JSON schema from localStorage", error);
  }
};
